import { SVGProps, Ref, forwardRef } from 'react';

export const GridFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1c-4.375 0-5 .625-5 5s.625 5 5 5 5-.625 5-5-.625-5-5-5m12 0c-4.375 0-5 .625-5 5s.625 5 5 5 5-.625 5-5-.625-5-5-5M1 18c0-4.375.625-5 5-5s5 .625 5 5-.625 5-5 5-5-.625-5-5m17-5c-4.375 0-5 .625-5 5s.625 5 5 5 5-.625 5-5-.625-5-5-5"
                fill="currentColor"
            />
        </g>
    </svg>
));
GridFilledSize24Glyph.displayName = 'GridFilledSize24Glyph';
